export default "__VITE_ASSET__BpVCDnWz__"